import React from 'react';
import { Stack } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import { BasicActionDialog } from 'features/ui/base-dialogs';
import PaiSelect from 'features/ui/base-components/pai-select';
import PaiMenuItem from 'features/ui/base-components/pai-menu-item';
import { OptionType } from 'features/ui/base-components/pai-auto-complete';

interface Props {
  open: boolean;
  loading: boolean;
  gender: string;

  handleGenderChange(event: React.ChangeEvent<HTMLInputElement>): void;
  handleClose(): void;
  handleEditGender(): void;
}

const EditGenderDialog: React.FC<Props> = ({
  open,
  loading,
  gender,
  handleGenderChange,
  handleClose,
  handleEditGender
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const options: OptionType[] = [
    { label: t('femaleGender'), value: 'female' },
    { label: t('maleGender'), value: 'male' }
  ];

  return (
    <BasicActionDialog
      open={open}
      loading={loading}
      dialogTitle={t('editGender')}
      maxWidth="xs"
      proceedButtonText={t('save')}
      handleProceed={handleEditGender}
      proceedButtonDisabled={gender.trim() === ''}
      cancelButtonText={t('cancel')}
      handleClose={handleClose}
    >
      <Stack spacing={2} className={classes.dialogContent}>
        <PaiSelect label={t('contactGender')} value={gender} onChange={handleGenderChange}>
          {options.map((option) => (
            <PaiMenuItem key={option.value} value={option.value}>
              {option.label}
            </PaiMenuItem>
          ))}
        </PaiSelect>
      </Stack>
    </BasicActionDialog>
  );
};

const useStyles = makeStyles()(() => ({
  dialogContent: {
    // e.g. marginTop: theme.spacing(1),
  }
}));

export default EditGenderDialog;
